import { useTranslation } from 'react-i18next'

import { CorporateSupportLine } from '../CorporateSupportLine'

export default function CorporateAssist() {
  const { t } = useTranslation()

  return (
    <div
      className="flex flex-col gap-4"
      data-testid="container-corporate-assist"
    >
      <div
        className="flex justify-between items-center"
        data-testid="container-corporate-assist-header"
      >
        <h1
          className="text-2xl font-normal"
          data-testid="text-corporate-assist-heading"
        >
          {t('corporateAssist.title')}
        </h1>
      </div>

      <div
        className="mt-8 flex flex-col gap-4"
        data-testid="container-corporate-assist-content"
      >
        <p className="text-base" data-testid="text-corporate-assist-message">
          {t('corporateAssist.message')}
        </p>

        <CorporateSupportLine />
      </div>
    </div>
  )
}
